import axios from 'axios';

const api = axios.create({
    baseURL: '',
    headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;

export const authApi = {
    login: (username, password) => api.post('/api/auth/login', { username, password }),
    logout: () => api.post('/api/auth/logout'),
    changePassword: (currentPassword, newPassword) => api.put('/api/auth/password', { currentPassword, newPassword }),
};

export const licenseApi = {
    list: (params) => api.get('/api/licenses', { params }),
    listGrouped: (params) => api.get('/api/licenses/grouped', { params }),
    get: (id) => api.get(`/api/licenses/${id}`),
    create: (data) => api.post('/api/licenses', data),
    createMultipart: (formData) => api.post('/api/licenses', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    }),
    delete: (id) => api.delete(`/api/licenses/${id}`),
    download: (id) => api.get(`/api/licenses/${id}/download`, { responseType: 'blob' }),
    stats: () => api.get('/api/licenses/stats'),
    verify: (licenseContent) => api.post('/api/licenses/verify', { licenseContent }),
    getProducts: () => api.get('/api/licenses/products'),
    getHistory: (id) => api.get(`/api/licenses/${id}/history`),
    updateStatus: (id, status) => api.put(`/api/licenses/${id}/status`, { status }),
};

export const adminApi = {
    getUsers: () => api.get('/api/admin/users'),
    createUser: (data) => api.post('/api/admin/users', data),
    updateUser: (id, data) => api.put(`/api/admin/users/${id}`, data),
    deleteUser: (id) => api.delete(`/api/admin/users/${id}`),
    getProducts: () => api.get('/api/admin/products'),
    createProduct: (data) => api.post('/api/admin/products', data),
    updateProduct: (id, data) => api.put(`/api/admin/products/${id}`, data),
    deleteProduct: (id) => api.delete(`/api/admin/products/${id}`),
    getTables: () => api.get('/api/admin/db/tables'),
    getTable: (name) => api.get(`/api/admin/db/tables/${name}`),
    executeQuery: (sql) => api.post('/api/admin/db/query', { sql }),
};
